"use client";

import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

import WelcomeImageSrc from "@/imgs/welcome_screen.png";
import { Footer, MediaQuery } from "@/shared/components";
import { Button, Typography } from "@/shared/ui";
import LogoIcon from "@/svgs/haute-societe.svg";

import styles from "./page.module.scss";

const WelcomePage = () => {
  const { push } = useRouter();

  useEffect(() => {
    document.title = "Welcome | Societe";
  }, []);

  return (
    <main className={styles.container}>
      <Image src={WelcomeImageSrc} className={styles.welcomeImage} alt="welcome-image" />

      <div className={styles.content}>
        <div className={styles.top}>
          <LogoIcon className={styles.logoIcon} />
          <Typography italic as="h2" variant="footnote" align="center" className={styles.description}>
            Where exclusivity meets elegance
          </Typography>
        </div>

        <div className={styles.bottom}>
          <Button size="big" onClick={() => push("/auth/choose-role")}>
            Get Started
          </Button>
          <Typography variant="footnote" align="center">
            Already A Member?{" "}
            <Link className={styles.signupLink} href={"/auth/login"}>
              Login
            </Link>
          </Typography>
        </div>
      </div>
      <MediaQuery.Laptop>
        <Footer fixedAtBottom transparent />
      </MediaQuery.Laptop>
    </main>
  );
};

export default WelcomePage;
